// DEV-2684 Kural 1 — alt başlığı en az Görüntüle olan üst modül en az Görüntüle olmalı (sunucu da
// 422 ile zorlar). Rol matrisi ve yetki geçişi ekranı aynı kuralı buradan kullanır. Aile bağı
// sunucunun `ust` alanından okunur, ağaçtan ya da addan türetilmez (DEMİR KURAL #11).
import {YetkiKademe, kademeEnAz} from "@/enum/YetkiModulleri";

/** Kuralın okuduğu/yazdığı satır alanları (matris satırı ve geçiş hücresi aynı şekli taşır). */
export interface Kural1Satiri {
  kademe: YetkiKademe | string;
  ekle: boolean;
  degistir: boolean;
  sil: boolean;
  ust?: string | null;
}

export type Kural1Satirlari = { [modul: string]: Kural1Satiri };

/** ust -> o üste bağlı alt modüller (satırların geliş sırasıyla). */
export type UstHaritasi = { [ust: string]: string[] };

export function ustHaritasiKur(satirlar: Kural1Satirlari): UstHaritasi {
  const harita: UstHaritasi = {};
  Object.keys(satirlar).forEach((modul) => {
    const ust = satirlar[modul].ust;
    if (!ust) {
      return;
    }
    if (!harita[ust]) {
      harita[ust] = [];
    }
    harita[ust].push(modul);
  });
  return harita;
}

function altBaslikAcik(ust: string, satirlar: Kural1Satirlari, harita: UstHaritasi): boolean {
  return (harita[ust] || []).some((c) => {
    const cs = satirlar[c];
    return !!cs && kademeEnAz(cs.kademe, YetkiKademe.GORUNTULE);
  });
}

/** Üstün kilit kademesi: alt başlıklarından biri en az Görüntüle ise Görüntüle, değilse null. */
export function kural1Kilidi(modul: string, satirlar: Kural1Satirlari, harita: UstHaritasi): YetkiKademe | null {
  return altBaslikAcik(modul, satirlar, harita) ? YetkiKademe.GORUNTULE : null;
}

/**
 * Alt başlığı açık olup kendisi Görüntüle'den düşük her üstü Görüntüle'ye çıkarır (bayraklar
 * kapanır). N seviyede bir üstün yükselmesi onun üstünü tetikleyebildiği için değişiklik kalmayana
 * dek döner. Yükseltilen her üst için `yukseltildi` çağrılır; yükseltilenler döner.
 */
export function kural1Uygula(
  satirlar: Kural1Satirlari,
  harita: UstHaritasi,
  yukseltildi?: (ust: string) => void
): string[] {
  const yukseltilen: string[] = [];
  let degisti = true;
  while (degisti) {
    degisti = false;
    Object.keys(harita).forEach((ust) => {
      const us = satirlar[ust];
      if (!us) {
        return;
      }
      if (altBaslikAcik(ust, satirlar, harita) && !kademeEnAz(us.kademe, YetkiKademe.GORUNTULE)) {
        us.kademe = YetkiKademe.GORUNTULE;
        us.ekle = false;
        us.degistir = false;
        us.sil = false;
        yukseltilen.push(ust);
        if (yukseltildi) {
          yukseltildi(ust);
        }
        degisti = true;
      }
    });
  }
  return yukseltilen;
}
